import { render, staticRenderFns } from "./change-pass.vue?vue&type=template&id=2fd45a7a&"
import script from "./change-pass.vue?vue&type=script&lang=js&"
export * from "./change-pass.vue?vue&type=script&lang=js&"
import style0 from "./change-pass.vue?vue&type=style&index=0&id=2fd45a7a&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports